export default class UserType {
  /**
   * 分享者
   */
  static PROVIDER = "PROVIDER";
  /**
   * 使用者
   */
  static CONSUMER = "CONSUMER";
}
